// 2026-06-19 - FormuLearning - 테마(다크/라이트) 적용 유틸 (이슈 #9)
// 파일 위치: frontend/src/lib/theme.ts
// index.html의 FOUC 방지 인라인 스크립트와 키·기본값을 공유한다.

// mixed = 본문 라이트 + 헤더/메뉴 다크 (루트는 라이트, 해당 영역만 data-theme="dark")
export type Theme = 'dark' | 'light' | 'mixed'

export const THEME_KEY = 'theme'

// 저장값 우선, 없으면 시스템 설정(prefers-color-scheme), 기본 다크
export function getInitialTheme(): Theme {
  try {
    const stored = localStorage.getItem(THEME_KEY)
    if (stored === 'light' || stored === 'dark' || stored === 'mixed') return stored
    if (window.matchMedia('(prefers-color-scheme: light)').matches) return 'light'
  } catch {
    /* localStorage 접근 불가 시 다크 */
  }
  return 'dark'
}

// <html data-theme>에 반영 + 선호 저장
export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme)
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch {
    /* 저장 실패는 무시 */
  }
}
